// Squelette pose par le lot A (§10.1).
//
// FICHIER PARTAGE A MARQUES (§10.2). Les lots F et G n'ecrivent qu'a **leur**
// marque, jamais ailleurs dans ce fichier. Un conflit de fusion se resout alors
// en gardant toutes les lignes.
//
// Les marques sont en syntaxe TSX ({/* ... */}) et non en // : un commentaire
// de ligne place dans du JSX s'afficherait comme du texte a l'ecran.
//
// NOTE DU LOT F : le bloc d'attente du lot A (titre + sous-titre) a ete retire,
// puisqu'il s'affichait desormais au-dessus de chaque page. C'etait sa raison
// d'etre — occuper l'ecran jusqu'a l'arrivee de l'interface — et non un
// element a conserver. Voir docs/ECARTS.md.

import { Route, Routes } from 'react-router-dom'

import { Disposition } from './components/Disposition'
import { RouteProtegee } from './components/RouteProtegee'
import { AccueilParDefaut, ModuleRequis } from './lib/modules'
import { Cabinet } from './pages/Cabinet'
import { Connexion } from './pages/Connexion'
import { Disponibilites } from './pages/Disponibilites'
import { Facturation } from './pages/Facturation'
import { JournalAudit } from './pages/JournalAudit'
import { MotDePasseChanger, MotDePasseOubli, MotDePasseReinitialiser } from './pages/MotDePasse'
import { OrdonnanceFormulaire } from './pages/OrdonnanceFormulaire'
import { PatientDetail } from './pages/PatientDetail'
import { PatientFormulaire } from './pages/PatientFormulaire'
import { Patients } from './pages/Patients'
import { Planning } from './pages/Planning'
import { PlanningInfirmier } from './pages/PlanningInfirmier'
import { TypesSoins } from './pages/TypesSoins'
import { UtilisateurFormulaire } from './pages/UtilisateurFormulaire'
import { Utilisateurs } from './pages/Utilisateurs'

export default function App() {
  return (
    <Routes>
      {/* --- LOT F --- */}
      <Route path="/connexion" element={<Connexion />} />
      <Route path="/mot-de-passe/oubli" element={<MotDePasseOubli />} />
      <Route path="/mot-de-passe/reinitialiser" element={<MotDePasseReinitialiser />} />
      <Route
        path="/mot-de-passe/changer"
        element={
          <RouteProtegee>
            <MotDePasseChanger />
          </RouteProtegee>
        }
      />

      <Route
        element={
          <RouteProtegee>
            <Disposition />
          </RouteProtegee>
        }
      >
        <Route path="/" element={<AccueilParDefaut />} />
        <Route
          path="/planning"
          element={
            <ModuleRequis nom="planning" titre="Planning">
              <Planning />
            </ModuleRequis>
          }
        />
        <Route
          path="/mon-planning"
          element={
            <ModuleRequis nom="planning" titre="Mon planning">
              <PlanningInfirmier />
            </ModuleRequis>
          }
        />
        <Route path="/patients" element={<Patients />} />
        {/* Les chemins fixes priment sur `:id` par le classement de React
            Router : `/patients/nouveau` ne tombe jamais dans la fiche. */}
        <Route path="/patients/nouveau" element={<PatientFormulaire />} />
        <Route path="/patients/:id" element={<PatientDetail />} />
        <Route path="/patients/:id/modifier" element={<PatientFormulaire />} />
        <Route path="/patients/:id/ordonnances/nouvelle" element={<OrdonnanceFormulaire />} />
        <Route
          path="/disponibilites"
          element={
            <ModuleRequis nom="disponibilites" titre="Disponibilités">
              <Disponibilites />
            </ModuleRequis>
          }
        />
        <Route
          path="/facturation"
          element={
            <ModuleRequis nom="facturation" titre="Facturation">
              <Facturation />
            </ModuleRequis>
          }
        />

        {/* Reservees au titulaire (R6) : l'entree de menu est absente pour les
            autres roles, et un acces direct par URL tombe sur la page 403. */}
        <Route
          path="/utilisateurs"
          element={
            <RouteProtegee roles={['TITULAIRE']}>
              <Utilisateurs />
            </RouteProtegee>
          }
        />
        <Route
          path="/utilisateurs/nouveau"
          element={
            <RouteProtegee roles={['TITULAIRE']}>
              <UtilisateurFormulaire />
            </RouteProtegee>
          }
        />
        <Route
          path="/utilisateurs/:id/modifier"
          element={
            <RouteProtegee roles={['TITULAIRE']}>
              <UtilisateurFormulaire />
            </RouteProtegee>
          }
        />
        <Route
          path="/types-soins"
          element={
            <RouteProtegee roles={['TITULAIRE']}>
              <TypesSoins />
            </RouteProtegee>
          }
        />
        <Route
          path="/cabinet"
          element={
            <RouteProtegee roles={['TITULAIRE']}>
              <Cabinet />
            </RouteProtegee>
          }
        />
        <Route
          path="/journal-audit"
          element={
            <RouteProtegee roles={['TITULAIRE']}>
              <JournalAudit />
            </RouteProtegee>
          }
        />

        <Route path="*" element={<PageIntrouvable />} />
      </Route>
      {/* --- LOT G --- */}
    </Routes>
  )
}

function PageIntrouvable() {
  return (
    <div className="mx-auto max-w-lg p-8 text-center">
      <p className="text-5xl" aria-hidden="true">
        🧭
      </p>
      <h1 className="mt-4 text-2xl font-semibold text-slate-900">Page introuvable</h1>
      <p className="mt-2 text-slate-600">
        Cette adresse ne correspond à aucun écran de SoinsLib.
      </p>
    </div>
  )
}
